module.exports = __webpack_public_path__ + "static/media/Icon-cart.f83ac927.svg";